export function isFeatureEnabled(featureName: string) {
    let envName = "REACT_APP_FEATURE_" + featureName + "_ENABLED";
    let envValue = process.env[envName];
    console.log("process.env[" + envName + "]: " + envValue);
    return envValue == "true";
}